module.exports = __webpack_public_path__ + "static/img/chatatemushi_rui.1089706.jpg";